export enum OrderManualTaskTasksPriceRuleMode {
  Static = "Static",
  Percentage = "Percentage",
  PerMediaDurationMinute = "PerMediaDurationMinute",
}
